import { getSystemTimezone, getTimezoneOffsetMinutes } from '@ui/calendar/utils';

export const timezoneOptions = [
  { value: 'Etc/GMT+12', label: '(GMT-12:00) International Date Line West' },
  { value: 'Pacific/Pago_Pago', label: '(GMT-11:00) Midway Island, Samoa' },
  { value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii' },
  { value: 'America/Anchorage', label: '(GMT-09:00) Alaska' },
  { value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time' },
  { value: 'America/Denver', label: '(GMT-07:00) Mountain Time' },
  { value: 'America/Phoenix', label: '(GMT-07:00) Arizona' },
  { value: 'America/Chicago', label: '(GMT-06:00) Central Time' },
  { value: 'America/New_York', label: '(GMT-05:00) Eastern Time' },
  { value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time' },
  { value: 'America/St_Johns', label: '(GMT-03:30) Newfoundland' },
  { value: 'America/Sao_Paulo', label: '(GMT-03:00) Brazil, Buenos Aires' },
  { value: 'Atlantic/South_Georgia', label: '(GMT-02:00) Mid-Atlantic' },
  { value: 'Atlantic/Azores', label: '(GMT-01:00) Azores' },
  { value: 'Europe/London', label: '(GMT+00:00) London, Dublin, Lisbon' },
  { value: 'Europe/Berlin', label: '(GMT+01:00) Berlin, Paris, Rome, Madrid' },
  { value: 'Europe/Athens', label: '(GMT+02:00) Athens, Cairo, Jerusalem' },
  { value: 'Europe/Moscow', label: '(GMT+03:00) Moscow, Riyadh' },
  { value: 'Asia/Tehran', label: '(GMT+03:30) Tehran' },
  { value: 'Asia/Dubai', label: '(GMT+04:00) Dubai, Baku' },
  { value: 'Asia/Kabul', label: '(GMT+04:30) Kabul' },
  { value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi' },
  { value: 'Asia/Kolkata', label: '(GMT+05:30) India' },
  { value: 'Asia/Kathmandu', label: '(GMT+05:45) Kathmandu' },
  { value: 'Asia/Dhaka', label: '(GMT+06:00) Dhaka' },
  { value: 'Asia/Yangon', label: '(GMT+06:30) Yangon' },
  { value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok, Jakarta' },
  { value: 'Asia/Shanghai', label: '(GMT+08:00) Beijing, Singapore, Perth' },
  { value: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo, Seoul' },
  { value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide' },
  { value: 'Australia/Sydney', label: '(GMT+10:00) Sydney, Melbourne' },
  { value: 'Pacific/Guadalcanal', label: '(GMT+11:00) Solomon Islands' },
  { value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington' },
  { value: 'Pacific/Apia', label: '(GMT+13:00) Samoa' },
  { value: 'Pacific/Kiritimati', label: '(GMT+14:00) Line Islands' },
];

// resolve an IANA timezone to one of the options above: exact id first, then any option sharing the
// same current UTC offset, so an auto-selected zone always maps to a real, renderable option
export const resolveTimezoneOption = (timeZone: string): string => {
  if (timezoneOptions.some((option) => option.value === timeZone)) return timeZone;

  const targetOffset = getTimezoneOffsetMinutes(timeZone);
  if (targetOffset !== null) {
    const matchByOffset = timezoneOptions.find((option) => getTimezoneOffsetMinutes(option.value) === targetOffset);
    if (matchByOffset) return matchByOffset.value;
  }

  return 'Europe/London';
};

// the timezone to fall back to when none is set — the user's current local zone, mapped to an option
export const getDefaultTimezone = (): string => resolveTimezoneOption(getSystemTimezone());
